document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value
        }
      };
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      });
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }

      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);;

          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");

      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this.loading = true;

      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams]);
        return;
      }

      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          this.cachedResults[searchParams] = html;
          this._renderResults(html);
        });

      if (updateURLHash) this._updateURLHash(searchParams);
    },
    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      this.loading = false;
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      let activeTag = document.getElementById("active-filter-tag")

      if (activeTag) {
        activeTag.innerHTML = parsedHTML.getElementById("active-filter-tag").innerHTML;
      }
      if (selectBlockFiltesDrawer) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesDrawer.innerHTML = parsedHTML.querySelector(blockFiltesDrawer).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesAside.innerHTML = parsedHTML.querySelector(blockFiltesAside).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
        container.classList.remove('loading');
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.xViewport.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.xViewport.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});

// ============================================================
// CASCADING FILTER (v2): capone.categoria → gruppi misura
// ------------------------------------------------------------
// Struttura: un metafield misura SEPARATO per categoria.
//   - capone.misura_anello     → gruppo "Misura anello"
//   - capone.misura_bracciale  → gruppo "Misura bracciale"
//   - capone.lunghezza_collana → gruppo "Lunghezza collana"
// Comportamento:
//   - Nessuna categoria selezionata → i gruppi misura sono visibili
//     ma disabilitati/opachi (impostare SHOW_DISABLED_WHEN_EMPTY=false
//     per nasconderli del tutto).
//   - Categoria selezionata → resta visibile SOLO il gruppo misura
//     corrispondente (unione dei gruppi se più categorie selezionate);
//     gli altri vengono nascosti.
//   - Categoria senza gruppo misura (es. Orecchino) o non mappata →
//     non mostra nessun gruppo.
//   - I VALORI dentro ogni gruppo li restringe già Shopify in modo
//     nativo (via AJAX vengono renderizzati solo i valori con
//     prodotti corrispondenti): niente liste di valori da mantenere.
// Robustezza:
//   - Funziona su sidebar (.form-aside), drawer mobile (.form-drawer)
//     e layout "above"; si riaggancia dopo ogni refresh AJAX dei
//     filtri con un MutationObserver (il tema NON emette eventi
//     custom tipo `facets:updated`: _renderFilters() sostituisce
//     l'innerHTML dei form).
//   - ensureFormId(): fix di un bug del tema per cui l'id
//     #FacetFiltersForm resta sul form del drawer anche su desktop,
//     facendo perdere i click sui filtri della sidebar.
// ============================================================
(function () {
  'use strict';

  // Mappa categoria → gruppi misura da mostrare (param name Shopify
  // dei filtri su metafield prodotto). Confronto case-insensitive
  // con spazi normalizzati. Aggiungere qui eventuali nuove categorie.
  var GROUPS_BY_CATEGORIA = {
    'Anello':    ['filter.p.m.capone.misura_anello'],
    'Bracciale': ['filter.p.m.capone.misura_bracciale'],
    'Collana':   ['filter.p.m.capone.lunghezza_collana'],
    'Orecchino': []
  };

  // Tutti i param dei gruppi misura governati dalla cascata
  // (incluso il vecchio campo unico capone.misura: se il suo filtro
  // è ancora attivo in Search & Discovery viene gestito/nascosto).
  var SIZE_PARAMS = [
    'filter.p.m.capone.misura_anello',
    'filter.p.m.capone.misura_bracciale',
    'filter.p.m.capone.lunghezza_collana',
    'filter.p.m.capone.misura'
  ];

  var CATEGORIA_PARAM = 'filter.p.m.capone.categoria';
  var DISABLED_TITLE  = 'Seleziona prima una Categoria Gioiello';

  // true  → senza categoria i gruppi misura restano visibili ma opachi
  // false → senza categoria i gruppi misura sono nascosti del tutto
  var SHOW_DISABLED_WHEN_EMPTY = true;

  function norm(value) {
    return String(value == null ? '' : value).trim().toLowerCase().replace(/\s+/g, ' ');
  }

  var NORM_MAP = {};
  Object.keys(GROUPS_BY_CATEGORIA).forEach(function (key) {
    NORM_MAP[norm(key)] = GROUPS_BY_CATEGORIA[key];
  });

  function inputsByName(name, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll('input[name="' + name + '"]')
    );
  }

  // Gruppi filtro (.js-filter) per un param: sidebar, drawer e "above".
  function groupsFor(param) {
    var groups = [];
    inputsByName(param).forEach(function (input) {
      var group = input.closest('.js-filter');
      if (group && groups.indexOf(group) === -1) groups.push(group);
    });
    return groups;
  }

  function selectedCategorie() {
    return inputsByName(CATEGORIA_PARAM)
      .filter(function (input) { return input.checked; })
      .map(function (input) { return input.value; });
  }

  // Unione dei gruppi misura ammessi per le categorie selezionate.
  function allowedParams(categorie) {
    var allowed = {};
    categorie.forEach(function (categoria) {
      var list = NORM_MAP[norm(categoria)];
      if (list) {
        list.forEach(function (param) { allowed[param] = true; });
      }
      // Categoria non mappata: non contribuisce con nessun gruppo.
    });
    return allowed;
  }

  function setGroupDisabled(group, param, disabled) {
    group.classList.toggle('filter-misura-disabled', disabled);
    group.style.opacity = disabled ? '0.4' : '';
    group.style.pointerEvents = disabled ? 'none' : '';
    if (disabled) {
      group.setAttribute('title', DISABLED_TITLE);
    } else {
      group.removeAttribute('title');
    }
    var summary = group.querySelector('.facets__summary');
    if (summary) summary.setAttribute('aria-disabled', disabled ? 'true' : 'false');

    inputsByName(param, group).forEach(function (input) {
      if (disabled) {
        // Non marcare input già disabilitati dal Liquid (count == 0):
        // alla riattivazione non vanno riabilitati per errore.
        if (!input.disabled) input.setAttribute('data-cascade-disabled', '1');
        input.disabled = true;
      } else if (input.hasAttribute('data-cascade-disabled')) {
        input.removeAttribute('data-cascade-disabled');
        input.disabled = false;
      }
    });
  }

  function applyCascade() {
    // Se il filtro Categoria non è in pagina non interferiamo.
    if (!inputsByName(CATEGORIA_PARAM).length) return;

    var categorie = selectedCategorie();
    var allowed = allowedParams(categorie);
    var noneSelected = categorie.length === 0;

    SIZE_PARAMS.forEach(function (param) {
      groupsFor(param).forEach(function (group) {
        if (noneSelected) {
          if (SHOW_DISABLED_WHEN_EMPTY) {
            group.style.display = '';
            setGroupDisabled(group, param, true);
          } else {
            group.style.display = 'none';
          }
          return;
        }

        // Con categoria selezionata: visibile solo il gruppo mappato.
        // Un gruppo con filtri ATTIVI resta visibile comunque, così
        // l'utente può sempre deselezionarli.
        var hasActive = inputsByName(param, group).some(function (i) { return i.checked; });
        if (allowed[param] || hasActive) {
          group.style.display = '';
          setGroupDisabled(group, param, false);
        } else {
          group.style.display = 'none';
        }
      });
    });
  }

  // FIX difensivo: il tema legge i filtri da #FacetFiltersForm e sposta
  // quell'id tra .form-aside (desktop) e .form-drawer (mobile) in
  // _initLayout(). Quando lo spostamento non avviene, i click sulla
  // sidebar desktop vengono serializzati dal form sbagliato e il filtro
  // si "resetta". Stessa identica regola del tema (breakpoint 768px):
  // se lo stato è già corretto non tocca nulla.
  function ensureFormId() {
    var aside = document.querySelector('form.form-aside');
    var drawer = document.querySelector('form.form-drawer');
    var desktop = window.matchMedia('(min-width: 768px)').matches;
    if (desktop && aside) {
      if (aside.id !== 'FacetFiltersForm') aside.setAttribute('id', 'FacetFiltersForm');
      if (drawer && drawer.id === 'FacetFiltersForm') drawer.removeAttribute('id');
    } else if (drawer) {
      if (drawer.id !== 'FacetFiltersForm') drawer.setAttribute('id', 'FacetFiltersForm');
      if (aside && aside.id === 'FacetFiltersForm') aside.removeAttribute('id');
    }
  }

  var applyTimer = null;
  function applySoon() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(function () {
      ensureFormId();
      applyCascade();
    }, 60);
  }

  // Il tema sostituisce l'innerHTML di .form-aside / .form-drawer /
  // .filter-advanced dopo ogni fetch AJAX: i contenitori restano, i
  // gruppi interni vengono ricreati. Osserviamo i contenitori e
  // ri-applichiamo lo stato (le modifiche di soli attributi/stile non
  // generano mutation childList, quindi nessun loop).
  var observer = typeof MutationObserver !== 'undefined'
    ? new MutationObserver(applySoon)
    : null;

  function observeFilterContainers() {
    if (!observer) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('.form-aside, .form-drawer, .filter-advanced'),
      function (container) {
        if (container.getAttribute('data-cascade-observed')) return;
        container.setAttribute('data-cascade-observed', '1');
        observer.observe(container, { childList: true, subtree: true });
      }
    );
  }

  // Feedback immediato al cambio di una categoria, prima ancora che
  // arrivi la risposta AJAX (poi il MutationObserver ri-applica tutto).
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.name === CATEGORIA_PARAM) applySoon();
  }, true);

  function initCascade() {
    ensureFormId();
    observeFilterContainers();
    applyCascade();
  }

  // Ri-applica la regola dell'id anche al cambio di breakpoint
  // (stessa soglia usata dal tema in _initLayout).
  var mq = window.matchMedia('(min-width: 768px)');
  if (mq.addEventListener) {
    mq.addEventListener('change', function () { applySoon(); });
  } else if (mq.addListener) {
    mq.addListener(function () { applySoon(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCascade);
  } else {
    initCascade();
  }
})();
